{
  "pages": {
    "dashboard": {
      "greeting": {
        "morning": "காலை வணக்கம்",
        "afternoon": "மதிய வணக்கம்",
        "evening": "மாலை வணக்கம்"
      },
      "header": {
        "fallbackUser": "பயனர்",
        "facility": "சுகாதார மையம் {{id}}"
      },
      "criticalBanner": {
        "message_one": "{{count}} முக்கிய முடிவு உறுதிப்படுத்தல் தேவை",
        "message_other": "{{count}} முக்கிய முடிவுகள் உறுதிப்படுத்தல் தேவை",
        "reviewNow": "இப்போது பார்க்க"
      },
      "sections": {
        "overview": "மேலோட்டம்",
        "tasks": "பணிகள்",
        "myPatients": "என் நோயாளிகள்",
        "recentActivity": "சமீபத்திய செயல்பாடு",
        "quickActions": "விரைவு செயல்கள்"
      },
      "stats": {
        "activeEncounters": "செயலில் உள்ள வருகைகள்",
        "pendingOrders": "நிலுவையில் உள்ள ஆர்டர்கள்",
        "resultsToReview": "மீளாய்வு செய்ய வேண்டிய முடிவுகள்",
        "criticalAlerts": "முக்கிய எச்சரிக்கைகள்"
      },
      "tasks": {
        "unsignedNotes": "கையெழுத்திடப்படாத குறிப்புகள்",
        "criticalResultsPending": "நிலுவையில் உள்ள முக்கிய முடிவுகள்",
        "cosignaturesNeeded": "இணை கையெழுத்து தேவை",
        "ordersToReview": "மீளாய்வு செய்ய வேண்டிய ஆர்டர்கள்",
        "activeMedications": "செயலில் உள்ள மருந்துகள்",
        "admissionsPending": "சேர்க்கை நிலுவையில்",
        "ordersToVerify": "மருந்தாளர் சரிபார்ப்புக்கான ஆர்டர்கள்",
        "controlledSubstanceReviews": "கட்டுப்படுத்தப்பட்ட மருந்து மீளாய்வுகள்",
        "systemAlerts": "கணினி எச்சரிக்கைகள்",
        "systemStatus": "கணினி நிலை"
      },
      "systemStatusValue": {
        "healthy": "சாதாரணம்"
      },
      "empty": {
        "noPatients": "செயலில் உள்ள நோயாளிகள் ஒதுக்கப்படவில்லை.",
        "noTasks": "இந்த பாத்திரத்திற்கான பணிகள் இல்லை.",
        "noRecentEncounters": "சமீபத்திய வருகைகள் இல்லை."
      },
      "quickActions": {
        "findPatient": {
          "label": "நோயாளியை தேடு",
          "description": "பதிவுகளை தேடு"
        },
        "registerPatient": {
          "label": "நோயாளியை பதிவு செய்",
          "description": "புதிய நோயாளியை சேர்"
        },
        "viewCensus": {
          "label": "சென்சஸ் பார்வை",
          "description": "செயலில் உள்ள வருகைகள்"
        },
        "reports": {
          "label": "அறிக்கைகள்",
          "description": "பகுப்பாய்வைக் காண்க"
        }
      },
      "viewAll": "அனைத்தையும் காண்க",
      "bedLabel": "படுக்கை {{n}}",
      "admittedLabel": "அனுமதிக்கப்பட்டது {{date}}",
      "fallback": {
        "unknownPatient": "தெரியாத நோயாளி",
        "unknownType": "தெரியாதது"
      },
      "acuity": {
        "1": "மீட்பு",
        "2": "அவசர",
        "3": "உடனடி",
        "4": "குறைவான உடனடி",
        "5": "அவசரமற்ற"
      },
      "encounterType": {
        "emergency": "அவசர",
        "inpatient": "உள்நோயாளி",
        "outpatient": "வெளிநோயாளி",
        "observation": "கண்காணிப்பு"
      },
      "encounterStatus": {
        "active": "செயலில்",
        "completed": "முடிந்தது",
        "discharged": "வெளியேற்றப்பட்டது",
        "cancelled": "ரத்து செய்யப்பட்டது",
        "pending": "நிலுவையில்"
      }
    },
    "qualityMeasures": {
      "title": "தர அளவீடுகள்",
      "subtitle": "மருத்துவ தர அளவீடுகள் மற்றும் ஒழுங்குமுறை இணக்கத்தை கண்காணிக்கவும்",
      "refresh": "புதுப்பிக்கவும்",
      "allTypesLabel": "அனைத்து வகைகள்",
      "allFacilitiesLabel": "அனைத்து மையங்கள்",
      "targetPrefix": "இலக்கு: {{value}} {{unit}}",
      "updatedPrefix": "புதுப்பிக்கப்பட்டது: {{value}}",
      "measureType": {
        "process": "செயல்முறை",
        "outcome": "விளைவு",
        "structure": "கட்டமைப்பு"
      },
      "summary": {
        "totalMeasures": "மொத்த அளவீடுகள்",
        "meetingTarget": "இலக்கை அடைந்தது",
        "belowTarget": "இலக்கிற்கு குறைவாக"
      },
      "toasts": {
        "refreshSuccess": "அளவீடுகள் புதுப்பிக்கப்பட்டன"
      },
      "results": {
        "title": "பதிவு செய்யப்பட்ட முடிவுகள்",
        "period": "காலம்",
        "facility": "வசதி",
        "denominator": "பகுதி",
        "numerator": "தொகுதி",
        "exclusions": "விலக்குகள்",
        "rate": "விகிதம்",
        "source": "மூலம்",
        "calculated": "கணக்கிடப்பட்டது",
        "empty": "இந்த காலகட்டத்தில் இந்த அளவீட்டிற்கு முடிவுகள் எதுவும் பதிவு செய்யப்படவில்லை.",
        "loadError": "பதிவு செய்யப்பட்ட முடிவுகளை ஏற்ற முடியவில்லை.",
        "allFacilities": "அனைத்து மையங்கள்",
        "record": "முடிவைப் பதிவு செய்க"
      },
      "sources": {
        "manual": "கைமுறை",
        "sql-template": "SQL வார்ப்புரு",
        "import": "இறக்குமதி"
      },
      "qrda": {
        "download": "QRDA III",
        "measureDownload": "QRDA",
        "success": "QRDA அறிக்கை பதிவிறக்கப்பட்டது",
        "error": "QRDA பதிவிறக்கம் தோல்வியடைந்தது"
      },
      "record": {
        "title": "தர முடிவைப் பதிவு செய்க",
        "titleFor": "முடிவைப் பதிவு செய்க — {{code}} {{name}}",
        "subtitle": "பதிவு செய்யப்பட்ட முடிவுகள் அளவீட்டு வரலாற்றில் தோன்றி QRDA வகை III ஏற்றுமதியில் சேரும். ஒரு காலத்தை மீண்டும் பதிவு செய்தால் முந்தைய வரி மாற்றப்படும்.",
        "back": "தர அளவீடுகளுக்குத் திரும்புக",
        "cancel": "ரத்து செய்க",
        "save": "முடிவைப் பதிவு செய்க",
        "measureNotFound": "அளவீடு கிடைக்கவில்லை. அது செயலிழக்கெச் செய்யப்பட்டிருக்கலாம்.",
        "fields": {
          "periodStart": "காலத் தொடக்கம்",
          "periodEnd": "கால முடிவு",
          "facility": "வசதி",
          "allFacilities": "அனைத்து மையங்கள்",
          "denominator": "பகுதி",
          "numerator": "தொகுதி",
          "exclusions": "விலக்குகள்",
          "source": "கணக்கீட்டு மூலம்",
          "completeness": "தரவு முழுமை",
          "completenessHint": "முழுமையான தரவுள்ள தகுதிப் பதிவுகளின் பின்னம், 0 முதல் 1. தெரியாவிட்டால் காலியாக விடுக.",
          "notes": "குறிப்புகள்"
        },
        "errors": {
          "periodStartRequired": "காலத் தொடக்கம் தேவை",
          "periodEndRequired": "கால முடிவு தேவை",
          "periodOrder": "கால முடிவு, தொடக்கத்திற்குப் பின் அல்லது அதே நாளில் இருக்க வேண்டும்",
          "countInvalid": "0 அல்லது அதற்கு மேற்பட்ட முழு எண்ணை உள்ளிடுக",
          "numeratorExceeds": "தொகுதி பகுதியை மிஞ்சக்கூடாது",
          "numeratorExceedsNet": "தொகுதி, பகுதியிலிருந்து விலக்குகள் கழித்த மீதியை மிஞ்சக்கூடாது",
          "sourceRequired": "கணக்கீட்டு மூலம் தேவை",
          "completenessRange": "முழுமை 0 முதல் 1 வரை இருக்க வேண்டும்"
        },
        "toast": {
          "success": "முடிவு பதிவானது",
          "error": "பதிவு தோல்வியடைந்தது"
        }
      }
    },
    "analyticsDashboard": {
      "title": "பகுப்பாய்வு டாஷ்போர்டு",
      "subtitle": "மருத்துவமனை செயல்திறன் அளவீடுகள் மற்றும் போக்குகள்",
      "refresh": "புதுப்பிக்கவும்",
      "changeVsPrevPeriod": "முந்தைய காலத்துடன் ஒப்பிடும்போது {{sign}}{{value}}%",
      "dateRange": {
        "today": "இன்று",
        "7d": "7 நாட்கள்",
        "30d": "30 நாட்கள்",
        "90d": "90 நாட்கள்"
      },
      "facility": {
        "all": "அனைத்து மையங்கள்",
        "sgh": "SGH - சிங்கப்பூர் ஜெனரல் மருத்துவமனை",
        "nuh": "NUH - தேசிய பல்கலைக்கழக மருத்துவமனை",
        "ttsh": "TTSH - டான் டாக் செங் மருத்துவமனை"
      },
      "department": {
        "all": "அனைத்து துறைகள்",
        "er": "அவசர சிகிச்சை",
        "icu": "தீவிர சிகிச்சைப் பிரிவு",
        "medsurg": "மருத்துவம்/அறுவை சிகிச்சை",
        "peds": "குழந்தை மருத்துவம்",
        "maternity": "மகப்பேறு"
      },
      "widget": {
        "census": {
          "title": "தற்போதைய நோயாளி எண்ணிக்கை"
        },
        "bedOccupancy": {
          "title": "படுக்கை பயன்பாடு"
        },
        "avgLOS": {
          "title": "சராசரி தங்கும் காலம்"
        },
        "throughput": {
          "title": "மொத்த சந்திப்புகள்"
        },
        "readmission": {
          "title": "நிலுவையில் உள்ள ஆர்டர்கள்"
        }
      },
      "unit": {
        "patients": "நோயாளிகள்",
        "days": "நாட்கள்",
        "encounters": "சந்திப்புகள்",
        "orders": "ஆர்டர்கள்"
      },
      "charts": {
        "admissionsVsDischarges": "சேர்க்கைகள் vs வெளியேற்றங்கள்",
        "admissionsByDepartment": "துறை வாரியான சேர்க்கைகள்",
        "encounterTypes": "சந்திப்பு வகைகள்",
        "censusTrend": "நோயாளி எண்ணிக்கை போக்கு",
        "insufficientData": "வரைபடத்திற்கு போதிய தரவு இல்லை",
        "insufficientTrendData": "போக்கு வரைபடத்திற்கு போதிய தரவு இல்லை"
      },
      "series": {
        "admissions": "சேர்க்கைகள்",
        "discharges": "வெளியேற்றங்கள்",
        "census": "நோயாளி எண்ணிக்கை"
      },
      "toasts": {
        "refreshSuccess": "டாஷ்போர்டு புதுப்பிக்கப்பட்டது"
      }
    },
    "reportRunner": {
      "title": "அறிக்கை இயக்கி",
      "subtitle": "மருத்துவ, நிதி, செயல்பாட்டு அறிக்கைகளை உருவாக்கி ஏற்றுமதி செய்க",
      "scheduleButton": "அறிக்கையை திட்டமிடுக",
      "searchPlaceholder": "அறிக்கைகளைத் தேடுக...",
      "allCategoriesLabel": "அனைத்து அறிக்கைகள்",
      "category": {
        "clinical": "மருத்துவம்",
        "financial": "நிதி",
        "operational": "செயல்பாடு",
        "quality": "தரம்"
      },
      "emptyState": {
        "title": "தொடங்க ஒரு அறிக்கையைத் தேர்ந்தெடுக்கவும்",
        "subtitle": "இடதுபுற அறிக்கைப் பட்டியலில் இருந்து தேர்வுசெய்க"
      },
      "noResults": "உங்கள் வடிகட்டிகளுக்குப் பொருந்தும் அறிக்கை எதுவும் இல்லை",
      "parametersHeading": "அளவுருக்கள்",
      "selectOptionPlaceholder": "தேர்வுசெய்க...",
      "runButton": "அறிக்கையை இயக்குக",
      "runningReport": "அறிக்கை இயக்கப்படுகிறது...",
      "exportCsv": "CSV",
      "exportPdf": "PDF",
      "format": {
        "csv": "CSV",
        "pdf": "PDF"
      },
      "columnLabel": {
        "facilityLocalDate": "தேதி (மையத்தின் உள்ளூர் நேரம்)",
        "facilityTimeZone": "மையத்தின் நேர மண்டலம்",
        "encounterDate": "தேதி (UTC)"
      },
      "resultSummary": {
        "rows": "{{total}} வரிசைகளில் {{shown}} காட்டப்படுகின்றன",
        "executed": "{{ms}}ms இல் செயல்படுத்தப்பட்டது"
      },
      "toasts": {
        "success": "அறிக்கை {{executionTimeMs}}ms இல் முடிந்தது - {{rowCount}} வரிசைகள்",
        "failed": "அறிக்கையை இயக்க முடியவில்லை",
        "missingFields": "தேவையான புலங்களை நிரப்பவும்: {{missingFields}}",
        "exporting": "{{format}} ஆக ஏற்றுமதி செய்யப்படுகிறது... (இடப்பகுதி)",
        "scheduledPlaceholder": "திட்டமிடப்பட்ட அறிக்கை அமைப்பு (இடப்பகுதி)"
      }
    }
  }
}
